import { PersistWebData } from './persistwebdata';

export class WebSessionStorage implements PersistWebData{
 
    private storage:Storage;

    constructor(){
        this.storage = window.sessionStorage;
    }

    getItem(key: string): string|null {
        return this.storage.getItem(key);
    }    
    
    setItem(key: string, value: string): void {
        this.storage.setItem(key, value);
    }

    removeItem(key: string): void {
        this.storage.removeItem(key);
    }

    clear(): void {
        this.storage.clear();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/persist/websessionstorage.ts